<template>
  <R3Title title="Reporting ❯ Tank History Detail"></R3Title> <!-- unicode U+276F : ❯ -->
  <div v-if="loading" class="loading-overlay">
    LOADING...
    <span class="loader"></span>
  </div>
  <div v-else>
  <div style="margin-left: 40px; margin-right: 50px; width: 90%; max-width: 80%;">
    <div style="font-size: 24px;"> {{ currentContainer.containerName }} </div>
    <div v-html="subtitle" style=""></div>
  </div>

  <div style="margin-left: 40px; margin-right: 50px; width: 90%; max-width: 80%;">
    <DxBox :height="50" direction="row" width="100%" class="tb">
      <DxItem :ratio="0" :base-size="400">
        <DxButtonGroup :items="rangeGroup" :selected-item-keys="selectedRangeKeys" key-expr="range" styling-mode="outline"
          @item-click="rangeDaysChange" />
      </DxItem>
      <DxItem :ratio="0" :base-size="400">
        <DateRangePicker v-model="customDateRange" :visible="showPicker" @error:invalid-range="handleInvalidRange" />
      </DxItem>
      <DxItem :ratio="0" :base-size="120">
        <DxButton v-if="showPicker" text="Apply" @click="applyCustomDateRange" icon="check" type="default"
          class="apply-button" />
      </DxItem>
    </DxBox>
  </div>

  <div style="width: 79%;">
    <R3GraphHistoryVolume
      :containerId="currentRecordId" 
      :container="currentContainer" 
      :range-days="rangeDays"
      :vol-view-detail="volViewDetail" 
    />
    
  </div>
  
  <!-- <div v-if="currentContainer" style="margin-left: 40px; margin-right: 50px; width: 90%; max-width: 80%;"> -->    
  <div v-if="currentContainer && !isOperator" style="margin-left: 40px; margin-right: 50px; width: 90%; max-width: 80%;">
    <DxDataGrid class="dx-card wide-card" :data-source="volumeDetail" :hover-state-enabled="true"
      :selection="{ mode: 'single' }" :show-borders="true" :columns-auto-width="false" :column-min-width="50"
      :allow-column-resizing="true" :column-resizing-mode="currentMode" :allow-column-reordering="true"
      no-data-text="Loading ..." @selection-changed="masterSelectionChanged" @row-click="dataRowToggle"
      @initialized="saveGridInstance">
      <DxStateStoring :enabled="true" type="localStorage" storage-key="rep_container_history_detail_single" />
      <DxExport :enabled="true" />
      <DxColumnChooser :enabled="true" mode="select" />
      <DxFilterRow :visible="true" />
      <DxHeaderFilter :visible="true" />

      <DxColumn data-field="containerName" caption="Name" min-width="125" />
      <DxColumn data-field="Downhole LSD" caption="Downhole LSD" min-width="125" />
      <DxColumn data-field="Alias" caption="Alias" min-width="125" />
      <DxColumn data-field="historyDate" caption="Date" data-type="datetime" format="shortDateShortTime" min-width="150" />
      <DxColumn data-field="Product" caption="Product" min-width="125" />
      <DxColumn data-field="propValue" :caption="volumeDetail[0]?.propertyName || 'Volume'" min-width="125" />
      <DxColumn data-field="historyType" caption="History Type" min-width="125" />
    </DxDataGrid>
  </div>
    
  <!-- </div> -->
  
  <DxLoadPanel v-model:visible="loadingVisible" :message="Loading" :show-indicator="true" :show-pane="true"
    :shading="true" :hide-on-outside-click="false" :on-shown="onLoadPanelShown" :on-hidden="onLoadPanelHidden"
    shading-color="rgba(0,0,0,0.4)" />

  <DxToast v-model:visible="toastVisible" v-model:message="toastMessage" v-model:type="toastType"
    position="bottom center" />
  </div>
</template>

<script>

import R3Title from "@/components/base/page-title.vue";

import R3GraphHistoryVolume from "@/components/container/graphs/graph-history-volume-detail.vue";

import {
  DxDataGrid,
  DxColumn,
  DxHeaderFilter,
  DxFilterRow,
  DxColumnChooser,
  DxStateStoring,
  DxExport
} from "devextreme-vue/data-grid";
import { DxButton } from "devextreme-vue/button";
import DxButtonGroup from "devextreme-vue/button-group";
import { DxBox, DxItem } from "devextreme-vue/box";
import DateRangePicker from "@/components/custom/date-range-picker.vue";
import { confirm } from "devextreme/ui/dialog";
import { DxLoadPanel } from "devextreme-vue/load-panel";
import { DxToast } from "devextreme-vue/toast";
import notify from "devextreme/ui/notify";

export default {
  components: {
    R3Title,
    /* eslint-disable-next-line */
    R3GraphHistoryVolume,
    DxExport,
    DxDataGrid,
    DxColumn,
    DxHeaderFilter,
    DxFilterRow,
    DxColumnChooser,
    DxStateStoring,
    DxButton,
    DxButtonGroup,
    DxBox,
    DxItem,
    DateRangePicker,
    
    DxLoadPanel,
    DxToast,
  },
  created() {
    this.loadPageData();
  },
  data() {
    return {
      dataGridInstance: null,
      currentMode: "widget",
      containerName: "-",
      containerDownhole: "-",
      currentContainer: [],
      currentProperties: [],
      currentHistoryType: 90,
      properties: [],
      currentHistory: [],
      isOperator: false,
      user: null,
      rangeGroup: [
        {
          range: "14",
          text: "14 days",
        },
        {
          range: "30",
          text: "30",
        },
        {
          range: "60",
          text: "60",
        },
        {
          range: "90",
          text: "90",
        },
        {
          range: "custom",
          text: "Custom",
        },
      ],
      rangeDays: 30,
      customDateRange: {
        start: null,
        end: null,
      },
      isCustomRange: false,
      volViewDetail: false,
      showPicker: false,
      loading: true,
      loadingVisible: false,
      toastVisible: false,
      toastMessage: "",
      toastType: "info",
      toastPosition: {
        at: "bottom",
        my: "top",
        of: "#pwreset",
      },
    };
  },
  computed: {
    // Keeps the highlighted range button in sync with rangeDays / custom range.
    selectedRangeKeys() {
      return this.isCustomRange ? ["custom"] : [String(this.rangeDays)];
    },
    currentRecordId() {
      return parseInt(
        this.$route.path.substring(this.$route.path.lastIndexOf("/") + 1)
      );
    },
    containers() {
      return this.$store.getters["containers/getContainerHistoryDetail"];
    },
    volumeDetail() {
      // Was returning the raw getter, so the grid ignored the range buttons.
      const data = this.$store.getters["containers/getContainerHistoryDetail"];
      const dateCriteria = new Date();
      dateCriteria.setDate(dateCriteria.getDate() - this.rangeDays);
      return data
        .filter((item) => item.historyDate >= dateCriteria)
        .map((item) => ({
          ...item,
          containerName: this.currentContainer.containerName,
          "Downhole LSD": this.currentContainer["Downhole LSD"],
          Alias: this.currentContainer["Alias"],
          Product: this.currentContainer["Product"],
        }));
    },
    containerVolumeHistoryDetail() {
      const currentHistoryType = this.rangeDays;
      var data = this.$store.getters["containers/getContainerHistoryDetail"];

      const volumeHist = [];
      var dateCriteria = new Date();
      dateCriteria.setDate(dateCriteria.getDate() - currentHistoryType);

      for (const key in data) {
        if (
          data[key].propertyName === "Volume (L)" &&
          data[key].historyDate >= dateCriteria
        ) {
          const hist = {
            historyId: data[key].historyId,
            customerId: data[key].customerId,
            containerId: data[key].containerId,
            containerName: data[key].containerName,
            propertyId: data[key].propertyId,
            historyDate: data[key].historyDate,
            // historyDate: data[key].historyDate.getFullYear() + "-" + ("0"+(data[key].historyDate.getMonth()+1)).slice(-2) + "-" + ("0" + data[key].historyDate.getDate()).slice(-2) + " " + data[key].historyDate.getDate().slice(-8),
            propValue: parseFloat(data[key].propValue),
            historyType: data[key].historyType,
            notes: data[key].notes,
            propertyName: data[key].propertyName,
          };
          volumeHist.push(hist);
        }
      }
      return volumeHist;
    },
    containerVolumeHistory() {
      var data = this.$store.getters["containers/getContainerHistoryDetail"];
      const volumeHist = [];
      var dateCriteria = new Date();
      dateCriteria.setDate(dateCriteria.getDate() - this.currentHistoryType);

      for (const key in data) {
        if (
          data[key].propertyName === "Volume (L)" &&
          data[key].historyDate >= dateCriteria
        ) {
          // if (data[key].propertyName==="Volume (L)")
          const hist = {
            historyId: data[key].historyId,
            customerId: data[key].customerId,
            containerId: data[key].containerId,
            containerName: data[key].containerName,
            propertyId: data[key].propertyId,
            // historyDate: Date.parse(data[key].historyDate),
            // historyDate: data[key].historyDate,
            // historyDate: data[key].historyDate.getFullYear() + "-" + (data[key].historyDate.getMonth() + 1) + "-" + data[key].historyDate.getDate(),
            historyDate:
              data[key].historyDate.getFullYear() +
              "-" +
              ("0" + (data[key].historyDate.getMonth() + 1)).slice(-2) +
              "-" +
              ("0" + data[key].historyDate.getDate()).slice(-2),
            propValue: parseFloat(data[key].propValue),
            historyType: data[key].historyType,
            notes: data[key].notes,
            propertyName: data[key].propertyName,
          };
          volumeHist.push(hist);
        }
      }
      return volumeHist;
    },
    subtitle() {
      const headerprops = this.$store.getters["properties/getHeaderProperties"];
      var st = "<div>";
      for (let i = 0; i < headerprops.length; i++) {
        st += headerprops[i].propertyName + ': ' + this.currentContainer[headerprops[i].propertyName] + '</div><div>';
      }
      st+='</div>'
      return st;
    },
  },
  methods: {
    customizeTooltip(pointInfo) {
      return {
        html: `
          <div>
            <div style="width: 100px;padding:5px;text-align: center;"><span style="font-size:18px;font-weight:bold;">${pointInfo.value}</span></div>
            <div style="width: 100px;padding:5px;text-align: center;">${pointInfo.argumentText}</div>
          </div>`,
      };
    },
    saveGridInstance: function (e) {
      this.dataGridInstance = e.component;
    },
    getPropertyVal(propName) {
      let retVal = "-";
      // console.log(this.currentHistory);
      if (
        this.containers[0].containerName !== undefined &&
        this.containers[0].containerName !== null
      ) {
        //console.log ("PROP", this.currentHistory[this.currentHistory.length-1][propName])
        retVal = this.currentHistory[this.currentHistory.length - 1][propName];
      }
      return retVal;
    },
    
    updateHistType(e) {
      this.currentHistoryType = e.value;
    },
    refreshData() {
      this.loadPageData();
    },
    gotoDetail() {
      this.$router.push({
        name: "reporting-containers-status-details",
        params: { id: this.currentRecordId },
      });
    },
    async loadPageData(refresh = false) {
      this.loading = true;
      try {
        if (this.currentRecordId != null && this.currentRecordId !== undefined && this.currentRecordId > 0) {
          await this.$store.dispatch("containers/clearContainerHistory");
          await Promise.all([
            this.$store.dispatch("containers/loadContainerStatus", this.currentRecordId),
            // this.$store.dispatch("containers/loadContainerHistory", this.currentRecordId),
            this.$store.dispatch("containers/loadContainerHistoryDetail", this.currentRecordId),
            // this.$store.dispatch("containers/loadContainerHistoryExtended", this.currentRecordId),
            this.$store.dispatch("properties/loadProperties"),
            this.$store.dispatch("users/loadProfile")
          ])
        }
        this.user = this.$store.getters["users/getProfile"];
        this.isOperator = this.user.defaultView?.toLowerCase() == 'operator';
        this.currentContainer = this.$store.getters["containers/getContainerStatus"];
        this.properties = this.$store.getters["properties/getProperties"];
        // this.parseContainerHistory();
      } catch (error) {
        this.error = error.message || "Unexpected Error.";
      } finally {
        this.loading = false;
      }
    },
    rangeDaysChange(e) {
      if (e.itemData.range === "custom") {
        this.showPicker = true;
        this.isCustomRange = true;
      } else {
        if (this.isCustomRange) {
          this.refreshData();
          this.isCustomRange = false;
        }
        this.showPicker = false;
        this.customDateRange.start = null;
        this.customDateRange.end = null;
        this.rangeDays = Number(e.itemData.range);
      }
    },
    async applyCustomDateRange() {
      const fromDate = new Date(this.customDateRange.start);
      const today = new Date();
      const diffTime = Math.abs(today - fromDate);
      var diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      if (diffDays > 90) {
        confirm(
          `<div style="text-align: center;">
            <b>The selected date range is greater than 90 days and may take a while to load. Do you want to continue?</b>
          </div>`,
          "Continue?"
        ).then(async (confirmed) => {
          if (confirmed) {
            await this.loadContainterHistoryWithCustomDateRange(diffDays);
          }
        });
      }
      else {
        await this.loadContainterHistoryWithCustomDateRange(diffDays);
      }
    },
    async loadContainterHistoryWithCustomDateRange(diffDays) {
      this.loadingVisible = true;
      this.rangeDays = diffDays;

      await this.$store.dispatch("containers/loadContainerHistoryDetail", {
        containerId: this.currentRecordId,
        fromDate: this.customDateRange.start,
        toDate: this.customDateRange.end,
      });
      this.loadingVisible = false;
    },
    handleInvalidRange(message = "End date must be after start date") {
      this.popNotification(message, "warning");
    },
    popNotification(msg, type) {
      //types ['error', 'info', 'success', 'warning']
      const position = "center";
      const direction = "down-stack";
      notify(
        {
          message: msg,
          type: type,
        },
        {
          position,
          direction,
        }
      );
    },
  },
};
</script>

<style scoped>
.tb {
  margin: 40px 0 0 0;
}

.menubar {
  padding: 0 60px 0 60px;
}

.apply-button {
  margin-top: 6%;
}
</style>
